module.exports = "pegasus_template/assets/lp/ebook/logo.png";